'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++)arr2[i]=arr[i];return arr2}else{return Array.from(arr)}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');

const cx=require('../../../dist-es6/shared/extensions/classExtensions');
const PersonStatisticsViewModel=require('../../../dist-es6/client/viewModels/personStatisticsViewModel');
const DashboardPersonViewModel=require('../../../dist-es6/client/viewModels/dashboardPersonViewModel');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const TimeSeries=require('../../../dist-es6/client/utilities/timeSeries');
const AlertStatusCache=require('../../../dist-es6/client/viewModels/alertStatusCache');
const ex=require('pulsar-utils/dist-es6/ex');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const Formatters=require('../../../dist-es6/client/formatters');
const fpe=require('../../../dist-es6/shared/extensions/fatiguePointExtensions');
const fe=require('../../../dist-es6/shared/extensions/fatigueExtensions');

const FifteenMinutesInMilliseconds=timespan.fromMinutes(15).totalMilliseconds();
const ExpectedNormalWorkdayInHours=14;

const NotApplicableAlertInfo={
label:'N/A',
interval:null,
status:ThresholdStatus.NotApplicable};let


ForecastPersonViewModel=function(_DashboardPersonViewM){_inherits(ForecastPersonViewModel,_DashboardPersonViewM);
function ForecastPersonViewModel(){_classCallCheck(this,ForecastPersonViewModel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key]}var _this=_possibleConstructorReturn(this,
_DashboardPersonViewM.call.apply(_DashboardPersonViewM,[this].concat(args)));

_this._currentStatusSource=_.exists(_this,'statistics.effectiveStatus.time')?'effectiveStatus':'lastKnownStatus';

cx(_this).defineLazyGetters({
forecast:function(){return _.get(_this,'statistics.forecast',null)},
schedule:function(){return _.get(_this,'statistics.forecast.schedule',null)},
scenario:function(){return _.get(_this,'statistics.forecast.scenario',null)},
predictedWorkday:function(){return _.get(_this,'statistics.forecast.predictedWorkday',null)},
workdayStart:function(){return _.get(_this,'statistics.forecast.predictedWorkday.start',null)},
currentHosStatus:function(){return _.get(_this,'statistics.forecast.currentHosStatus',null)},
incidents:function(){return _.get(_this,'statistics.forecast.incidents',null)},
effectiveStatus:function(){return _.get(_this,'statistics.effectiveStatus',null)},
isAlertingSinceStart:function(){return _this.currentAlertInfo&&
_this.currentAlertInfo.status.value==='Above'&&
_.result(_this,'scenario.fatigue[0].time.getTime')===_this.currentAlertInfo.interval.start.getTime()},

currentAlertInfo:function(){return _this.getAlertInfoAt(_this.currentTimeForForecast)},
currentThreshold:function(){return _this.thresholdFor(NotificationType.AllThresholdsExceeded)},

currentStatus:function(){return _this._getCurrentStatusWithLastPointBeforeCurrentTime()},
_realCurrentStatus:function(){return _this._getRealCurrentStatus()},

fatigueWithStatuses:function(){return[].concat(_toConsumableArray(fpe(_.get(_this,'scenario.fatigue',[])).withAlertStatusesAndInterpolations(_this.currentThreshold)))},

alertRanges:function(){return _this._getAlertRanges()},
visibleAlertRanges:function(){return _this._getVisibleAlertRanges()},

peakWorkdayTimeSeriesPoint:function(){return _this._getPeakWorkdayTimeSeriesPoint()},
peakWorkdayFatigue:function(){return _.get(_this.peakWorkdayTimeSeriesPoint,'value',null)},

combinedDuties:function(){return TimeInterval.compress(_.get(_this,'schedule.duties',[]))},

inServiceViolation:function(){return _this.predictedWorkday&&_this.predictedWorkday.duration.totalHours()!==ExpectedNormalWorkdayInHours}});return _this;

}ForecastPersonViewModel.prototype.





getAlertInfoAt=function getAlertInfoAt(time){
if(_.isDate(time)&&!Number.isNaN(time.getTime())){
const visibleAlertInfo=_getAlertInfoFor({
alertRanges:{
Above:TimeInterval.compress(this.visibleAlertRanges.past.Above.concat(this.visibleAlertRanges.future.Above)),
At:TimeInterval.compress(this.visibleAlertRanges.past.At.concat(this.visibleAlertRanges.future.At)),
Below:TimeInterval.compress(this.visibleAlertRanges.past.Below.concat(this.visibleAlertRanges.future.Below)),
NotApplicable:TimeInterval.compress(this.visibleAlertRanges.past.NotApplicable.concat(this.visibleAlertRanges.future.NotApplicable))},

time:time});


if(_.exists(visibleAlertInfo)){
return _.assign(visibleAlertInfo,{
urgent:visibleAlertInfo.status===ThresholdStatus.Above&&visibleAlertInfo.label==='current'&&this._realCurrentStatus.onDuty});

}
}

return NotApplicableAlertInfo;
};ForecastPersonViewModel.prototype.

_getRealCurrentStatus=function _getRealCurrentStatus(){
const currentStatus=_.get(this,this._currentStatusSource,{});

if(!_.isDate(currentStatus.time)){
currentStatus.time=new Date(currentStatus.time);
}

if(currentStatus.fatigue){
currentStatus.thresholdStatus=ThresholdStatus.fromScoreAndThreshold(currentStatus.fatigue,this.currentThreshold);
}

return currentStatus;
};ForecastPersonViewModel.prototype.

_getAlertRanges=function _getAlertRanges(){
const alertIntervals=_getFreshAlertIntervals();

if(!this._thresholdCache||!this.scenario){
return alertIntervals;
}

const threshold=this.currentThreshold;

return fpe(this.scenario.fatigue).getAlertRangesFor(threshold);
};ForecastPersonViewModel.prototype.

_getVisibleAlertRanges=function _getVisibleAlertRanges(){
const{scenario:scenario,combinedDuties:combinedDuties,predictedWorkday:predictedWorkday}=this;

const visibleAlertRanges={
past:_getFreshAlertIntervals(),
future:_getFreshAlertIntervals()};


if(!scenario){
return visibleAlertRanges;
}

const currentUnixTime=this.currentTimeForForecast.getTime();
const threshold=this.currentThreshold;

if(predictedWorkday.start.getTime()<currentUnixTime){
const pastPredictionWindow=TimeInterval.from(predictedWorkday.start).to(currentUnixTime);
const pastDuties=TimeInterval.clip(this.combinedDuties).to(pastPredictionWindow);

if(pastDuties.length){
visibleAlertRanges.past=fpe(scenario.fatigue).getAlertRangesOverlapping(threshold,pastDuties);
}
}

if(currentUnixTime<predictedWorkday.end.getTime()){
const futurePredictionWindow=TimeInterval.from(currentUnixTime).to(predictedWorkday.end);

visibleAlertRanges.future=fpe(scenario.fatigue).getAlertRangesOverlapping(threshold,[futurePredictionWindow]);
}

return visibleAlertRanges;
};ForecastPersonViewModel.prototype.

_getPeakWorkdayTimeSeriesPoint=function _getPeakWorkdayTimeSeriesPoint(){
const workdayDutyPeriodsIncludingFuture=_.compact(_.concat.apply(_,_toConsumableArray(_.values(this.visibleAlertRanges.past)).concat(_toConsumableArray(_.values(this.visibleAlertRanges.future)))));
const peakFatigue=fe(this.fatigueWithStatuses).peakConsistentWithFatigueApi(workdayDutyPeriodsIncludingFuture);
if(peakFatigue&&peakFatigue.time.getTime()>this.currentTimeForForecast.getTime()){
peakFatigue.forecasted=!0;
}
return peakFatigue;
};ForecastPersonViewModel.prototype.

_getCurrentStatusWithLastPointBeforeCurrentTime=function _getCurrentStatusWithLastPointBeforeCurrentTime(){var _this2=this;
const realCurrentStatus=this._realCurrentStatus;

const interpolatedCurrentPoint=_.findLast(this.fatigueWithStatuses,function(tsp){return tsp.time.getTime()<=_this2.currentTimeForForecast.getTime()});

if(!_.exists(interpolatedCurrentPoint)){
return realCurrentStatus;
}

return _.defaults({
fatigue:interpolatedCurrentPoint.value,
thresholdStatus:interpolatedCurrentPoint.status,
time:interpolatedCurrentPoint.time},
realCurrentStatus);
};_createClass(ForecastPersonViewModel,[{key:'currentTimeForForecast',get:function(){return this.statistics.currentTime}}]);return ForecastPersonViewModel}(DashboardPersonViewModel);


const _getFreshAlertIntervals=function(){return{
Above:[],
At:[],
Below:[],
NotApplicable:[]}};


const alertInfoTypes=[{
label:'current',
predicate:function(interval,time){return interval.contains(time)}},
{
label:'future',
predicate:function(interval,time){return interval.start.getTime()>time.getTime()},
setup:function(intervals){return intervals.slice().reverse()}},
{
label:'recent',
predicate:function(interval,time){return interval.end.getTime()<time.getTime()}}];


const ThresholdStatusesInDescendingPrecedence=['Above','At','Below','NotApplicable'];

function _getAlertInfoFor(_ref){let{alertRanges:alertRanges,time:time}=_ref;
for(const rangeType of ThresholdStatusesInDescendingPrecedence){
for(const _ref2 of alertInfoTypes){const{label:label,predicate:predicate,setup=_.identity}=_ref2;
const intervals=setup(alertRanges[rangeType]);

const foundInterval=intervals.find(function(interval){return predicate(interval,time)});

if(_.exists(foundInterval)){
return{
interval:foundInterval,
status:ThresholdStatus[rangeType],
label:label};

}
}
}
}

module.exports=ForecastPersonViewModel;
//# sourceMappingURL=forecastPersonViewModel.js.map
